// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-4dfa1a16] {\n  text-decoration: none;\n}\n.errorItem[data-v-4dfa1a16] {\n  padding-left: 1.5rem;\n}\nh5[data-v-4dfa1a16] {\n  color: rgba(0, 0, 0, 0.6);\n  font-weight: 400;\n  font-size: 1rem;\n}\n.createNew[data-v-4dfa1a16] {\n  font-style: italic;\n  font-size: 0.8rem;\n  text-align: right;\n  margin-bottom: 0.5rem;\n}\n.information-block[data-v-4dfa1a16] {\n  font-style: italic;\n}", ""]);
// Exports
module.exports = exports;
